/*
 * @Author: Michael Lam 127068684+MichaelLam888@users.noreply.github.com
 * @Date: 2026-05-06 23:50:31
 * @LastEditTime: 2026-06-23 21:58:59
 * @Description: 
 */

import { useTranslation } from 'react-i18next';
import Button from '../../../components/base/Button';
import WindowsMt5DownloadModal from '../../../components/download/WindowsMt5DownloadModal';
import { useWindowsMt5Download } from '../../../hooks/useWindowsMt5Download';
import { getAndroidDownloadRouteUrl } from '../../../utils/androidDownload';

export default function HeroSection() {
  const { t } = useTranslation();
  const androidDownloadLink = getAndroidDownloadRouteUrl();
  const {
    showWindowsMt5Modal,
    checkingWindowsMt5Region,
    closeWindowsMt5Modal,
    handleWindowsMt5DownloadClick,
  } = useWindowsMt5Download();

  return (
    <section className="site-hero relative flex items-center justify-center overflow-hidden bg-gradient-to-br from-amber-50 via-white to-amber-50">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-10"
        style={{
          backgroundImage: `url('/img/857864968931d66bd25b732dcfdacf26.jpg')`
        }}
      />
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-left">
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
              MetaTrader 5
              <span className="block text-amber-600">(MT5)</span>
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
             {t('platform.etw')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <Button
                type="button"
                onClick={handleWindowsMt5DownloadClick}
                disabled={checkingWindowsMt5Region}
                className="bg-amber-600 hover:bg-amber-700 text-white px-8 py-4 text-lg whitespace-nowrap disabled:cursor-not-allowed disabled:opacity-70"
              >
                <i className="ri-download-line mr-2"></i>
                {checkingWindowsMt5Region ? t("download.checkingRegion", { defaultValue: "識別中..." }) : `${t('platform.download')}MT5`}
              </Button>

              {/* App Store Button */}
              <a href="https://apps.apple.com/us/app/metatrader-5/id413251709"><button className="bg-black hover:bg-gray-800 text-white px-6 py-3 rounded-lg flex items-center gap-3 transition-colors whitespace-nowrap">
                <i className="ri-apple-fill text-2xl"></i>
                <div className="text-left">
                  <div className="text-xs">{t("download.appStorePrompt", { defaultValue: "Download on the" })}</div>
                  <div className="text-sm font-semibold">App Store</div>
                </div>
              </button></a>
              
              {/* Google Play Button */}
              <a href={androidDownloadLink}>
              <button className="bg-black hover:bg-gray-800 text-white px-6 py-3 rounded-lg flex items-center gap-3 transition-colors whitespace-nowrap">
                <i className="ri-google-play-fill text-2xl"></i>
                <div className="text-left">
                  <div className="text-xs">{t("download.googlePlayPrompt", { defaultValue: "GET IT ON" })}</div>
                  <div className="text-sm font-semibold">Google Play</div>
                </div>
              </button></a>
            </div>
            
            {/* Key Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-gray-200">
              <div className="text-center">
                <div className="text-2xl font-bold text-amber-600">0.01s</div>
                <div className="text-sm text-gray-600">{t('platform.es')}</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-amber-600">24/7</div>
                <div className="text-sm text-gray-600">{t('platform.th')}</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-amber-600">100+</div>
                <div className="text-sm text-gray-600">{t('platform.in')}</div>
              </div>
            </div>
          </div>
          
          {/* Right Content - Platform Screenshot */}
          <div className="relative">
            <div className="relative bg-white rounded-2xl shadow-2xl p-4 transform rotate-3 hover:rotate-0 transition-transform duration-500">
              <img 
                src="/img/1.png"
                alt="MetaTrader 5 Platform Interface"
                className="w-full h-auto rounded-lg"
              />
              <div className="absolute -top-4 -right-4 bg-amber-600 text-white px-4 py-2 rounded-full text-sm font-semibold">
                {t('platform.lt')}
              </div>
            </div>
          </div>
        </div>
      </div>

      <WindowsMt5DownloadModal open={showWindowsMt5Modal} onClose={closeWindowsMt5Modal} />
    </section>
  );
}
